import { apiUrl } from "../../config/base.js";
import axios from 'axios';

export default {

	getPropertySuggestions(searchBy, search, county) {
		return axios.get(apiUrl + '/get-property-suggestions?searchBy=' + searchBy + '&search=' + search + '&county=' + county);
	},

	search(account_no, county, intent) {
		return axios.get(apiUrl + '/' + account_no + '/search?county=' + county + '&intent=' + intent);
	},

	create(payload) {
		return axios.post(apiUrl + '/protest-requests/store', payload);
	},

	updateSignature(signature, user_property_uid) {
		return axios.post(apiUrl + '/user-properties/' + user_property_uid + '/add-update-authorize-signature', { signature: signature });
	},

	storeEvidences(protest_request_uid, requestPayload, isOperatorEditing) {
			console.log("storeEvidences - requestPayload:",requestPayload);
			var postUrl;
			if(isOperatorEditing){
				postUrl = 	apiUrl + '/operator/protest-requests/' + protest_request_uid + '/evidences/upload';
			}else{
				postUrl = 	apiUrl + '/protest-requests/' + protest_request_uid + '/evidences';
			}
			return axios.post(postUrl, requestPayload, {
				headers: {
					'content-type': 'multipart/form-data'
				}
			});
	},
	getCurrentStep(accountNo) {
		return axios.get(apiUrl + '/getCurrentStep/' + accountNo );
	},
	signRevokeAoaAgreement(signature, user_property_uid) {
		return axios.post(apiUrl + '/user-properties/' + user_property_uid + '/add-revoke-aoa-signature', { signature: signature });
	},

	storeAdditionalInformation(protest_request_uid, requestPayload) {
		return axios.post(apiUrl + '/protest-requests/' + protest_request_uid + '/additional-information', requestPayload);
	},

  changeMailingAddress(user_property_uid, payload, is_admin = false){
		if (is_admin) {
			return axios.post(apiUrl + '/admin/aoa-review-system/user-properties/' + user_property_uid + '/change-mailing-address', payload);
		}
        return axios.post(apiUrl + '/user-properties/' + user_property_uid + '/edit', payload);
    },

  storeConfirmToProtest(user_property_uid, payload){
        return axios.post(apiUrl + "/user-properties/" + user_property_uid + '/confirm-to-protest', payload);
  },


	//// Final outcome page api's
	storeFeedbackFormData(payload){
        return axios.post(apiUrl + "/protest-requests/final-outcome/submit-feedback-form", payload);
	},

	storeTellUsHereFeedback(payload){
        return axios.post(apiUrl + "/protest-requests/final-outcome/tell-us-here", payload);
	},

	getFrequentlyAskedQuestions(){
		return axios.post(apiUrl + "/protest-requests/final-outcome/frequently-asked-questions");
	},







	// by operator
	saveEvidence(requestPayload) {
		return axios.post(apiUrl + '/operator/save-image', requestPayload, {
			headers: {
				'content-type': 'multipart/form-data'
			}
		});
	},
	// by operator
	deleteEvidenceImage(protest_request_evidence_uid, comment) {
		return axios.post(apiUrl + '/operator/' + protest_request_evidence_uid + '/delete-evidence', { comment: comment });
	},

	// by operator
	changeEvidenceStatus(protest_request_uid, comment, statusValue, costOfRepairRating = null, calculatedCostofRepairViaRating = null) {
		return axios.post(apiUrl + '/operator/' + protest_request_uid + '/change-evidence-status', { comment: comment, status: statusValue, costOfRepairRating:costOfRepairRating, calculatedCostofRepairViaRating:calculatedCostofRepairViaRating });
	},

	// by operator
	includeEvidence(protest_request_evidence_uid) {
		return axios.post(apiUrl + '/operator/' + protest_request_evidence_uid + '/include-evidence');
	},

	// by operator
	getInternalUserActivites(protest_request_uid) {
		return axios.post(apiUrl + '/operator/' + protest_request_uid + '/get-internal-user-activites');
	},

	deleteEvidence(protest_request_uid, protest_request_evidence_uid) {
		return axios.delete(apiUrl + '/protest-requests/' + protest_request_uid + '/evidences/' + protest_request_evidence_uid);
	},

	// update(data, protest_request) {
	// 	return axios.post(apiUrl + '/protest-requests/' + protest_request.uid + '/update', { data : data });
	// },

	resignAoaAgreement(signature, user_property_uid) {
		return axios.post(apiUrl + '/user-properties/' + user_property_uid + '/re-sign-aoa', { signature: signature })
	},
	// updateTitles(data, protest_request) {
	// 	return axios.post(apiUrl + '/protest-requests/' + protest_request.uid + '/updateTitles', { data : data });
	// },

	confirmToProtest(user_property_uid, payload) {
		return axios.post(apiUrl + "/user-properties/" + user_property_uid + '/confirm-to-protest', payload);
	},

	update(protest_request_uid, payload, is_admin = false) {
		if (is_admin) {
			return axios.post(apiUrl + "/admin/protest-requests/" + protest_request_uid + '/update', payload);
		}

		return axios.post(apiUrl + "/protest-requests/" + protest_request_uid + '/update', payload);
	},

	operatorGenerateEvidenceReportPDF(protest_request_uid){
		return axios.post(apiUrl + "/operator/protest-requests/" + protest_request_uid + '/generateEvidenceReportPDF', null);
	}


}

